module.exports = __webpack_public_path__ + "static/media/veneto-3-04.8bf80a20.jpg";